<app-header></app-header>
<div id="collection-page" class="page-wrapper subscribe custom-calss">
    <div class="ult-checkout-section wf-section">
        <div class="collection-padding">

            <!-- Black Friday Sale Banner -->
            <div class="black-friday-banner-container" (click)="navigateToCollection2()">
                <!-- Desktop Banner -->
                <img src="assets/images/logos/black_friday_web_banner.png" alt="Black Friday Sale" class="black-friday-banner-image desktop-banner">
                <!-- Mobile Banner -->
                <img src="assets/images/logos/black_friday_mobile_banner.png" alt="Black Friday Sale" class="black-friday-banner-image mobile-banner">
            </div>

            <h1 class="checkout-h1 smart-order-h1-choose" [ngStyle]="{'text-transform': (PageTitle=='IRT - responsibletechnology.org') ? 'math-auto' :'capitalize'}">{{PageTitle ? PageTitle : _router.url.includes("Collection9") ? 'Convention 2025' : 'Category Name'}}</h1>
            <ng-container *ngIf="_router.url.includes('Collection9')">
              <div class="banner-img">
                <iframe src="https://player.vimeo.com/video/1100542159?autoplay=1&muted=1&loop=1&title=0&byline=0&portrait=0" width="100%" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen class="mb-4 mt-4 banner-inner-img" style="border:0;"></iframe>
              </div>
            </ng-container>
            <br>
            <div class="w-layout-grid enhance-grid cen m-b-30" *ngIf="_enrollSession.mobileView && productList.length > 0">
                <div *ngFor="let topPick of productList" class="m-b-30">
                    <div class="itemBorder" (click)="productInfo(topPick)">
                        <img src="{{topPick.SmallPicture}}" loading="lazy" class="checkout-product-img checkout-product-img-grid cursor-pointer">
                    </div>
                    <div class="" (click)="productInfo(topPick)">
                        <div class="checkout-h2 enhance-grid-h2">
                            {{topPick.Description}}
                        </div>
                    </div>
                    <div class="enhance-grid-price mh-22" *ngIf="!_auth.isLoggedIn()">Loyal Customer : ${{topPick.Price |number : '1.2-2'}} USD</div>
                    <div class="enhance-grid-price mh-22" *ngIf="_auth.isLoggedIn()">
                        <div *ngFor="let itemprices of topPick.ItemPrices">
                          <span *ngIf="itemprices.PriceTypeID == _enrollSession.data.priceType">Your Price : ${{itemprices.Price |number : '1.2-2'}} USD</span>
                        </div>
                      </div>
                    <div class="enhance-grid-price mh-22 r-b" *ngIf="!_auth.isLoggedIn()">
                        <ng-container *ngFor="let itemprices of topPick.ItemPrices">
                            <span *ngIf="itemprices.PriceTypeID == 6">Full Retail : ${{itemprices.Price |number : '1.2-2'}} USD</span>
                        </ng-container>
                    </div>
                    <div class="enhance-grid-price mh-22 r-b" *ngIf="_auth.isLoggedIn()">
                        <ng-container *ngFor="let itemprices of topPick.ItemPrices">
                            <del *ngIf="itemprices.PriceTypeID == 6">Full Retail : ${{itemprices.Price |number : '1.2-2'}} USD</del>
                        </ng-container>
                    </div>
                    <div class="checkout-h3 enhance-grid-h3 p-l-r-b" *ngIf="false">{{topPick.ShortDetail3}}</div>
                    <a id="w-node-d1025827-125d-8cf9-12a6-1ad93c74399f-db337a59" class="button enhance-grid-button w-button hover-white" (click)="addToCart(topPick,1,2)">Add to Cart</a>
                </div>
            </div>
            <div class="w-layout-grid enhance-grid" [ngClass]="{'width-2-item': productList.length === 2}" *ngIf="!_enrollSession.mobileViewMethod() && productList.length > 0">
                <div *ngFor="let topPick of productList" class="m-b-30">
                    <div class="itemBorder-img" (click)="productInfo(topPick)" style="display: flex; justify-content: center; align-items: center;">
                        <div class="itemBorder">
                            <img src="{{topPick.SmallPicture}}" loading="lazy" class="checkout-product-img checkout-product-img-grid cursor-pointer">
                        </div>
                    </div>
                    <div class="" (click)="productInfo(topPick)">
                        <div class="checkout-h2 enhance-grid-h2">
                            {{topPick.Description}}
                        </div>
                    </div>
                    <div class="enhance-grid-price mh-22" *ngIf="!_auth.isLoggedIn()">Loyal Customer : ${{topPick.Price |number : '1.2-2'}} USD</div>
                    <div class="enhance-grid-price mh-22" *ngIf="_auth.isLoggedIn()">
                        <div *ngFor="let itemprices of topPick.ItemPrices">
                          <span *ngIf="itemprices.PriceTypeID == _enrollSession.data.priceType">Your Price : ${{itemprices.Price |number : '1.2-2'}} USD</span>
                        </div>
                      </div>
                    <div class="enhance-grid-price mh-22 r-b" *ngIf="!_auth.isLoggedIn()">
                        <ng-container *ngFor="let itemprices of topPick.ItemPrices">
                            <span *ngIf="itemprices.PriceTypeID == 6">Full Retail : ${{itemprices.Price |number : '1.2-2'}} USD</span>
                        </ng-container>
                    </div>
                    <div class="enhance-grid-price mh-22 r-b" *ngIf="_auth.isLoggedIn()">
                        <ng-container *ngFor="let itemprices of topPick.ItemPrices">
                            <del *ngIf="itemprices.PriceTypeID == 6">Full Retail : ${{itemprices.Price |number : '1.2-2'}} USD</del>
                        </ng-container>
                    </div>
                    <div class="checkout-h3 enhance-grid-h3 p-l-r-b" *ngIf="false">{{topPick.ShortDetail3}}</div>
                    <a class="button enhance-grid-button w-button hover-white" (click)="addToCart(topPick,1,2,sideNav);">Add to Cart</a>
                </div>
            </div>
            <div *ngIf="productList.length == 0">
                <h1 class="checkout-h1 smart-order-h1-choose">No products to display!</h1>
            </div>
            <div class="banner-img-bottom m-b-30">
                <img *ngIf="_router.url.includes('Collection9')" src="assets/images/Banner/NewConventionBanner2025(1).png" class="mt-4 banner-inner-img-bottom" alt="" width="100%" height="auto">
            </div>
            <app-footercomponent></app-footercomponent>
        </div>
    </div>
</div>